angular.module('qkr.coupon').controller('couponController', ($scope, couponService, $uibModal, $location,
                                                             messageService, appConfig, gettextCatalog, utils,
                                                             couponListInitData, merchantInfo, $log) => {
    // Help with errors and validation
    $scope.outletLevel = appConfig.outletLevel;
    $scope.pickingProduct = false;
    $scope.coupons = couponService.processCoupons(merchantInfo, couponListInitData.couponData.list);
    $scope.count = couponListInitData.couponData.count;
    $scope.merchantHasCoupons = couponListInitData.couponData.merchantHasCoupons;
    $scope.outlets = couponListInitData.outlets;
    $scope.currency = merchantInfo.defaultCurrency;
    $scope.filteredByOutlet = false;
    $scope.statuses = {
        STATUS_ACTIVE: gettextCatalog.getString('Active'),
        STATUS_INACTIVE: gettextCatalog.getString('Inactive'),
        STATUS_DRAFT: gettextCatalog.getString('Draft'),
        STATUS_EXPIRED: gettextCatalog.getString('Expired'),
        STATUS_START: gettextCatalog.getString('Start')
    };

    $scope.filters = {
        selectedOutlet: null,
        selectedStatus: $scope.statuses.STATUS_ACTIVE
    };

    $scope.filterStatuses = $scope.statuses;
    //remove start from filters list
    delete $scope.filterStatuses.STATUS_START;

    $scope.getColour = function(coupon) {
        const style = {color: "blue"};

        if (coupon.displayStatus === $scope.statuses.STATUS_EXPIRED
            || coupon.displayStatus === $scope.statuses.STATUS_INACTIVE) {
            style.color = "red";
        } else if (coupon.displayStatus === $scope.statuses.STATUS_ACTIVE) {
            style.color = "green";
        }
        return style;
    };

    $scope.changeSort = function(selectedSort) {
        if (selectedSort === $scope.selectedSort) {
            $scope.selectedSort = '-' + selectedSort;
        } else {
            $scope.selectedSort = selectedSort;
        }
    };

    $scope.showQrCode = function(coupon) {
        couponService.getCoupon(coupon.couponId).then((fullCoupon) => {
            couponService.openQRModal(fullCoupon);
        }).catch($log.error);
    };

    $scope.createCoupon = function() {
        utils.scrollToTop();
        $location.path('/merchant/coupon/create');
    };

    $scope.deleteCoupon = function(coupon) {
        const msgTrans = gettextCatalog.getString('Are you sure you want to delete');
        const msgTrans1 = gettextCatalog.getString('Delete Coupon');
        const msgTrans2 = gettextCatalog.getString('Delete');

        $scope.modalOpen = true;
        const modalInstance = $uibModal.open({
            template: require('../../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return msgTrans1;
                },
                confirmButtonName() {
                    return msgTrans2;
                },
                confirmMsg() {
                    return msgTrans + '"' + coupon.name + '"?';
                },
                multiMsgArray() {
                    return [];
                }
            }
        });

        modalInstance.result.then((result) => {
            $scope.modalOpen = false;
            if (result === 'ok') {
                deleteCoupon(coupon);
            }
        }).catch($log.error);
    };

    const deleteCoupon = function(coupon) {
        const couponIndex = $scope.coupons.indexOf(coupon);
        couponService.deleteCoupon(coupon)
            .then((promise) => {
                // Remove coupon from list
                $scope.coupons.splice(couponIndex, 1);
            }).catch(reason => {
            if (reason.data.exception) {
                messageService.error(reason.data.exception);
            }
        });
    };

    $scope.deactivate = function(coupon) {
        couponService.deactivateCoupon(coupon).then(() => {
            coupon.deactivated = true;
            $scope.loadCouponList();
        }).catch($log.error);
    };

    $scope.reactivate = function(coupon) {
        if (coupon.isExpired) {
            $uibModal.open({
                template: require('../../templates/common/modalPopup.html'),
                controller: 'CommonModalPopupController',
                windowClass: 'fade',
                backdrop: 'static',
                resolve: {
                    title() {
                        return 'Coupon is Expired';
                    },
                    message() {
                        return "You cannot activate a coupon with an expiry date earlier than today";
                    }
                }
            });
        } else {
            couponService.reactivateCoupon(coupon).then(() => {
                coupon.deactivated = false;
                coupon.isDraft = false;
                $scope.loadCouponList();
            }).catch((response) => {
                if (response.data.errors && response.data.errors[0]) {
                    $uibModal.open({
                        template: require('../../templates/common/modalPopup.html'),
                        controller: 'CommonModalPopupController',
                        windowClass: 'fade',
                        backdrop: 'static',
                        resolve: {
                            title() {
                                return 'No active product';
                            },
                            message() {
                                return response.data.errors[0].reason;
                            }
                        }
                    });
                }
            });
        }

    };

    $scope.allowedActivate = function(coupon) {
        return couponService.allowedActivate(coupon, $scope.coupons);
    };


    $scope.loadCouponList = function(offset, max) {
        $scope.loading = true;
        $scope.coupons = [];
        couponService.getCouponsList(offset, max, $scope.filters.selectedOutlet,
            $scope.filters.selectedStatus)
            .then(data => {
                $scope.coupons = couponService.processCoupons(merchantInfo, data.list);
                $scope.count = data.count;
                $scope.loading = false;
                $scope.merchantHasCoupons = data.merchantHasCoupons;
            })
            .catch($log.error);
    };
});




// WEBPACK FOOTER //
// ./src/coupons/controllers/coupon.controller.js